import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fr from 'vuetify/es5/locale/fr';
import colors from 'vuetify/lib/util/colors';

import RepriseTabIcon from '@/components/customIcons/RepriseTabIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: { light: { third: '#c71900', lightGray: '#f7f7f7' } }
  },
  icons: {
    iconfont: 'mdi',
    values: { 'reprise-tab-icon': { component: RepriseTabIcon } }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  }
});
